import { Service, signal } from '@angular/core';
import { ConfirmOptions } from '@app/types/confirm-options.type';

@Service()
export class ConfirmationService {
	public config = signal<ConfirmOptions | null>(null);
	
	private resolveFn!: (value: boolean) => void;

	confirm(options: ConfirmOptions): Promise<boolean> {
		this.config.set({
			title: 'Êtes-vous sûr.e ?',
			acceptLabel: 'Oui',
			rejectLabel: 'Non',
			acceptSeverity: 'danger',
			rejectSeverity: 'info',
			...options
		});

		return new Promise<boolean>((resolve) => {
			this.resolveFn = resolve;
		});
	}

	accept() {
		this.config.set(null);
		this.resolveFn(true);
	}

	reject() {
		this.config.set(null);
		this.resolveFn(false);
	}
}
